import { TooltipProps } from 'recharts';
import { ChartCustomTooltip } from '../ChartCustomTooltip/ChartCustomTooltip';
import {
  NameType,
  ValueType,
} from 'recharts/types/component/DefaultTooltipContent';
import { Heading } from '../Heading';
import classes from './AverageScoreChartTooltip.module.css';
import { Paragraph } from '../Paragraph';
import { DateUtils } from '../../utils/DateUtils';

type AverageScoreChartTooltipProps = {
  active?: boolean;
  props: TooltipProps<ValueType, NameType>;
};

export const AverageScoreChartTooltip = ({
  props,
  active,
}: AverageScoreChartTooltipProps) => {
  return (
    active && (
      <ChartCustomTooltip active={active}>
        <div className={classes.tooltip}>
          <Heading as="h4">{`${
            props.payload?.length && props.payload.length > 1
              ? `Undersøkelser "${props.payload[0].payload.title}"`
              : `Undersøkelse "${props.payload?.[0].payload.title}"`
          }`}</Heading>
          <Heading as="h5">
            {props.payload?.[0] && props.payload?.[0].payload.shortDate} -{' '}
            {DateUtils.getClockTimeFromDate(props.payload?.[0].payload.date)}
          </Heading>
          {props.payload?.map((item: any) => (
            <div className={classes.tooltipItem} key={item.dataKey}>
              <Paragraph size="lg" style={{ color: item.color }}>
                {item.name}:
              </Paragraph>
              <Paragraph size="lg" style={{ color: item.color }}>
                {item.value.toFixed(2)}
              </Paragraph>
            </div>
          ))}
        </div>
      </ChartCustomTooltip>
    )
  );
};
